import Vue from 'vue'
import Router from 'vue-router'
import Session from '@/handler/session'
import Profiles from '@/config/profiles'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffIndex = () => import('./staff/index')

Vue.use(Router)

const isStaff = (to, from, next) => {
  if (Session.getSession().auth) {
    var perfil_id = parseInt(Session.getSession().auth.user.profile_id)
    if (perfil_id === Profiles.PERSONAL) {
      next()
    } else {
      next({ name: 'Error404' })
    }
  } else {
    next({ name: 'Init' })
  }
}

const router =
  [
    {
      path: '/st/changelog',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'ChangelogStaff',
          component: ViewStaffIndex,
          beforeEnter: isStaff,
          meta: {
            title: 'Registro de Cambios',
          }
        },
      ]
    },
  ]

export default router
